<af-main-container #mainContainer
                   [title]="(refundId ? 'i18n_lib_breadcrumb#EditRefund' : 'i18n_lib_breadcrumb#CreateRefund') | translate"
                   [customLastBreadcrumb]="'i18n_lib_breadcrumb#IncidentId' | translate :{incidentId: incident?.id ?? incidentId}"
                   [navigateBackListener]="navigateBack"
                   [queryParamsHandling]="'merge'"
                   [breadcrumbCustomizer]="breadcrumbCustomizer">
    @if (currentStep === lastStep) {
        <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            @if (form.getRawValue().commonForm.refundType === RefundType.PROSECUTOR_ORDER) {
                <ui-kit-button
                    type="secondary"
                    [disabled]="form.invalid"
                    [label]="'i18n_af_buttonPreviewResolution' | translate"
                    (clickListener)="previewResolution()"/>
            }
            <ui-kit-button
                type="primary"
                [disabled]="isSubmitting"
                [label]="buttonLabel | translate"
                (clickListener)="submitWithStatus()"/>
        </div>
    } @else if (isEditBySender) {
        <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <ui-kit-button
                type="secondary"
                [label]="'i18n_af_buttonCancel' | translate"
                (clickListener)="mainContainer.breadcrumbs.navigateBack()"/>
            <ui-kit-button
                type="primary"
                [label]="'i18n_af_buttonSave' | translate"
                (clickListener)="updateBySender()"/>
        </div>
    }
    @if (isEditByInitiator || isEditByNpckAdmin) {
        <ui-kit-stepper #stepper class="mt-32"
                        [currentStep]="currentStep"
                        [steps]="steps"
                        (submit)="submit()"
                        (stepIndexChangeListener)="currentStep = steps[$event]"/>
        <af-warning-panel class="w-100 mt-24"
                          warningText="i18n_af_warningPanelRefund"
                          buttonLabel="i18n_af_buttonDocumentation"
                          (clickListener)="downloadDocument()"/>
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100 overflow-y-hidden">
            @for (step of steps; track step) {
                @if (step === 'refundCommonInfo' && step === currentStep) {
                    <af-refund-common-information-step [form]="form.controls.commonForm"
                                                       [incidentId]="incidentId"
                                                       [refund]="refund"
                                                       class="w-100 mt-24 h-fit-content overflow-y-scroll"
                                                       (nextStep)="stepper.nextStep()"
                                                       fxFlex
                                                       (cancel)="openCancellationWarningDialog()"/>
                }
                @if (step === 'refundTransaction' && step === currentStep) {
                    <af-refund-transaction-step [form]="form.controls.transactionForm"
                                                [incidentId]="incidentId"
                                                [sender]="sender"
                                                [receiver]="receiver"
                                                [refundType]="form.getRawValue().commonForm.refundType"
                                                [refund]="refund"
                                                [showDraftButton]="isEditByInitiator"
                                                class="w-100 mt-24 h-fit-content overflow-y-scroll"
                                                (nextStep)="stepper.nextStep()"
                                                (previousStep)="stepper.previousStep()"
                                                fxFlex
                                                (cancel)="openCancellationWarningDialog()"/>
                }
            }
        </div>
    }
    @if (isEditBySender) {
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-fit-content overflow-y-scroll" fxLayoutGap="12px">
            <af-refund-transaction-step [form]="form.controls.transactionForm"
                                        [incidentId]="incidentId"
                                        [sender]="sender"
                                        [receiver]="receiver"
                                        [refundType]="form.getRawValue().commonForm.refundType"
                                        [refund]="refund"
                                        [isProcessingBySender]="true"
                                        class="w-100 mt-24"
                                        (cancel)="openCancellationWarningDialog()"/>
            <af-refund-common-information-step [form]="form.controls.commonForm"
                                               [incidentId]="incidentId"
                                               [refund]="refund"
                                               [isProcessingBySender]="true"
                                               class="w-100"
                                               (cancel)="openCancellationWarningDialog()"/>
        </div>
    }

</af-main-container>
